import intersectionBy from 'lodash/intersectionBy';

import type { HasMenuId } from '../../types';

// Add missing items and remove unknown or duplicate items
export const repairItems = <T extends HasMenuId>(items: T[], defaultItems: T[]) =>
	intersectionBy(items.concat(defaultItems), defaultItems, (item) => item.menuId);
